/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useState, useEffect} from "react";


import {Button, Col, Form, Row} from "react-bootstrap";

import {AiFillDelete, AiFillEdit, AiOutlineCheck, MdCancel, MdChangeCircle} from "react-icons/all";


import CompartmentProductsComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/Compartments/Compartment/Products";
import CompartmentProductReceiversComponent from "@UIPages/Authenticated/MonitoryNotes/_Parts/Compartments/Compartment/Receivers";


import COMPARTMENT_INTERFACE from "@Services/Application/Interfaces/Vehicles/Compartment";
import PRODUCT_INTERFACE from "@Services/Application/Interfaces/Products/Product";


type MonitoryNoteCompartmentsProps = {
    editable: boolean;
    compartment: [string, COMPARTMENT_INTERFACE];
    products?: PRODUCT_INTERFACE[];
    compartmentModifyHandler?: any;
    compartmentClearHandler?: any;
};

export const MonitoryNoteCompartmentComponent: React.FC<MonitoryNoteCompartmentsProps> = ({
    editable = false, compartment,
    products = null,
    compartmentModifyHandler = null, compartmentClearHandler = null
}): JSX.Element | null => {


    const [compartmentId, compartmentData] = compartment;

    const {
        capacity: compartmentCapacity, product: compartmentProductData, DefaultVol: compartmentDefaultVol
    } = compartmentData;

    const [compartmentEditActiveStatus, setCompartmentEditActiveStatus] = useState<boolean>(!!compartmentProductData);

    const changeCompartmentEditActiveStatus = (status: boolean) => {
        if (status === false) {
            compartmentClearHandler(compartmentId, compartmentActiveProductId);
        }
        setCompartmentEditActiveStatus(status);
    };

    const activeProductId: any = compartmentProductData ? `${compartmentProductData?.DispNo}${compartmentProductData?.ProductMasterNo}${compartmentProductData?.Pos}` : "";
    const [compartmentActiveProductId, setCompartmentActiveProductId] = useState<any>(activeProductId);

    const changeCompartmentActiveProductId = (e: React.ChangeEvent<HTMLInputElement>) => {
        const productID = e.target.value;
        if (!productID) {
            compartmentClearHandler(compartmentId, compartmentActiveProductId);
        }

        let product: any = (!!products && !!productID) ? products[productID as any] : null;
        let availableQuantity = product?.QtyAvail;
        let usedQuantity = 0;

        if (!product) return;

        for (let [id, cap] of Object.entries(product.productCompartments)) {
            if (id === compartmentId) continue;
            usedQuantity += Number(cap) || 0;
        }

        availableQuantity -= usedQuantity;

        let productCapacity = compartmentDefaultVol || 0;
        if (productCapacity > availableQuantity) productCapacity = availableQuantity;
        if (productCapacity < 0) productCapacity = 0;
        if (productCapacity > +(compartmentCapacity || 0)) productCapacity = +(compartmentCapacity || 0);

        setCompartmentActiveProductId(productID);
        setCompartmentActiveProductCapacity(productCapacity || "");        
    };

    const compartmentProduct: any = (!!products && !!compartmentActiveProductId) ? products[compartmentActiveProductId] : null;
    const [compartmentActiveProduct, setCompartmentActiveProduct] = useState<any>(compartmentProduct);

    const activeProductCapacity: any = compartmentProduct?.productCompartments && !!compartmentId ? compartmentProduct?.productCompartments[compartmentId] : "";
    const [compartmentActiveProductCapacity, setCompartmentActiveProductCapacity] = useState<any>(activeProductCapacity);

    const changeCompartmentActiveProductCapacity = (e: React.ChangeEvent<HTMLInputElement>) => {

        let productCapacity = +e.target.value;

        let availableQuantity = compartmentProduct?.QtyAvail;
        let usedQuantity = 0;

        if (!compartmentProduct) return;

        for (let [id, cap] of Object.entries(compartmentProduct.productCompartments)) {
            if (id === compartmentId) continue;
            usedQuantity += Number(cap) || 0;
        }

        availableQuantity -= usedQuantity;

        if (productCapacity > availableQuantity) productCapacity = availableQuantity;
        if (productCapacity < 0) productCapacity = 0;
        if (productCapacity > +(compartmentCapacity || 0)) productCapacity = +(compartmentCapacity || 0);

        setCompartmentActiveProductCapacity(productCapacity);

        compartmentModifyHandler(
            compartmentId,
            compartmentActiveProductId, productCapacity, compartmentProductReceiver
        );

    };

    const [compartmentProductReceiver, setCompartmentProductReceiver] = useState<string>(compartmentProduct?.ReceiverMasterNo || "");

    const changeCompartmentProductReceiver = (receiverId: string) => {
        setCompartmentProductReceiver(receiverId);
    };


    useEffect(() => {
        if (activeProductId === compartmentActiveProductId || !compartmentActiveProductId) return;
        compartmentModifyHandler(
            compartmentId,
            compartmentActiveProductId,
            compartmentActiveProductCapacity,
            // compartmentProductReceiver
        );
    }, [compartmentActiveProductId, compartmentActiveProductCapacity]);

    useEffect(() => {
        if (!compartmentProductReceiver || !compartmentActiveProductId) return;
        if (compartmentProductReceiver === compartmentProduct.ReceiverMasterNo) return;
        compartmentModifyHandler(
            compartmentId,
            compartmentActiveProductId,
            compartmentActiveProductCapacity,
            compartmentProductReceiver
        );
    }, [compartmentProductReceiver]);

    useEffect(() => {
        setCompartmentActiveProductId(activeProductId);
    }, [activeProductId]);

    useEffect(() => {
        setCompartmentActiveProduct(compartmentProduct);
    }, [compartmentActiveProductId]);

    useEffect(() => {
        setCompartmentEditActiveStatus(!!compartmentProduct);
        setCompartmentProductReceiver(compartmentProduct?.ReceiverMasterNo || "");
        setCompartmentActiveProductCapacity(compartmentProduct?.productCompartments[compartmentId] || "");
    }, [compartmentProduct, compartmentActiveProductId]);


    const compartmentPosition: string = compartmentId[1];
    const compartmentVehicle: string = compartmentId[0];

    const VEHICLES: any = {"F": "Pojazd Przedni", "R": "Pojazd Tylny"};



    return (
        <Col xs={12} className={"monitory-note-compartment-component monitory-note-compartment"}>
            <Row className={"monitory-note-compartment"}>

                <Col xs={12} className={"monitory-note-compartment-switcher"}>
                    <span className={"checkbox-button" + (!editable ? " inactive" : "")} onClick={() => editable ? changeCompartmentEditActiveStatus(!compartmentEditActiveStatus) : null}>
                        {compartmentEditActiveStatus && <AiOutlineCheck />}
                    </span>
                    <span className={"compartment-vehicle"}>{VEHICLES[compartmentVehicle]}</span>
                    <span className={"separator"}>{`/`}</span>
                    <span className={"compartment-position"}>Komora {compartmentPosition}</span>
                </Col>

                {compartmentEditActiveStatus &&
                <>

                 <CompartmentProductsComponent
                        compartmentActiveProduct={compartmentActiveProductId}
                        compartmentActiveProductHandler={changeCompartmentActiveProductId}
                        compartmentActiveProductCapacity={compartmentActiveProductCapacity}
                        compartmentActiveProductCapacityHandler={changeCompartmentActiveProductCapacity}
                        compartmentPosition={compartmentId}
                        compartmentCapacity={compartmentCapacity}
                        compartmentProducts={products}
                        compartmentSelectedProduct={compartmentProduct}
                        compartmentModifyHandler={null}
                        editable={editable}
                    />

                {!!compartmentActiveProduct &&
	            <CompartmentProductReceiversComponent
		            PRODUCT_RECEIVER_ID={compartmentProductReceiver}
		            PRODUCT_RECEIVER_HANDLER={changeCompartmentProductReceiver}
		            PRODUCT_DATA={compartmentProduct}
		            editable={editable}
	            />
                }

                </>
                }

            </Row>

        </Col>
    );

};


export default MonitoryNoteCompartmentComponent;
